export class InductionQuestionsListVM {
    public InductionTypes: InductionTypes[];
    public Slides: InductionSlides[];
    public Selections: InductionSlideSelection[];
    public QuestionsTypes: InductionQuestionTypesVM[];
    public Questions: InductionQuestionsVM[];
    public InductionInfo: InductionDetails;
}

export class InductionTypes {
    public ID: number;
    public Title: string;
    public Description: string;
    public ExpiryMonths: number | null;
}

export class InductionSlides {
    public ID: number;
    public Title: string;
    public Slide: string;
    public SlideSelectionId: number;
    public Active: boolean;
    public SlideImg: string;
    public SelectionName: string;
    public InductionTypeId: number;
    public Order: number;
    public VideoUrl: string;
    public SlideTypeId: number;
    public URL:string;
    public SlideData:string;
}

export class InductionSlideSelection {
    public ID: number;
    public Title: string;
    public InductionType: number | null;
    public Order: number;
    public Active: boolean;
    public Questions: InductionQuestionsVM[];
    public Slides: InductionSlides[];
}

export class InductionQuestionTypesVM {
    public Id: number;
    public Title: string;
    public Description: string;
}

export class InductionQuestionsVM {
    public Id: number;
    public Question: string;
    public Order: number;
    public QuestionTypeId: number;
    public InductionSlideId: number;
    public SlideSelectionId: number;
    public Active: boolean;
    public CorrectAns: number | null;
    public QuestionTypeName: string;
    public QuestionSlideName: string;
    public valid: boolean;
    public AnswerList: AnswerListVM[];
    public hasAnswers:boolean;

}

export class AnswerListVM {
    public Id: number;
    public Qid: number;
    public QuestionName: string;
    public answer: string;
    public correct: boolean=false;
    public Anscount: number | null;
    public userSelectAnswer: boolean;
    public valid: boolean;

}

export class InductionDetails {
    public InductionType: string;
    public date: Date;

}

export class ModalAddNewQuestions{
    public Title:string;
    public SlideId:number;
    public QuestionTypeId:number;
    public SelectionId:number;
    public QestionId:number|null;
}

export class AddQuestionAnsVM
{
   public AnswerList:AnswerListVM[]
   public QId:number;
    public AnswerTrue:number
    public QType:number
    public AnswerCount:number|null
}

export class PerformInductionVM{
    public Selections:InductionSlideSelection[]
    public Slides:InductionSlides[]
    public Questions:InductionQuestionsVM[]
    public Answers:AnswerListVM[]
    public InductionInfo:InductionDetails
    public username:string[]
    public InductionId:number
}


export class FacilitatorOverviewModel
    {
        public  UserId:number
        public  FullName:string
        public  UserName:string
        public  TeamName:string
        public  Email:string
        public  Access:string
        public  Disabled:boolean
    }